<template>
  <div class="create-work-form forgot" v-if="step === 0">
    <div class="header">
      <h2>Please, enter your email to receive<br/> instructions to resetting your <br/> password.</h2>
      <button class="close-btn" @click="close">×</button>
    </div>
    <div class="content w-full justify-center">
      <div class="w-full">
        <label>Email address</label>
        <input
            type="email"
            v-model="emailRef"
            class="create-input"
            @keyup.enter="submit"
            placeholder="Email address *"
        />
        <div v-if="!$v.emailRef.required && $v.emailRef.$error" class="error-message">
          Email is required
        </div>
        <div v-if="!$v.emailRef.email && $v.emailRef.$error || emailError" class="error-message">
          Emaıl address not found.
        </div>
      </div>

    </div>
    <div class="footer">
      <button :disabled="$v.$invalid" class="create-btn" @click="submit">
        Reset password
      </button>
    </div>

    <div v-if="loading" class="loading-overlay">
      <div class="spinner"></div>
    </div>
  </div>
  <div class="create-work-form" v-else>
    <div class="header-2">
      <h2>
        Please check your email for<br/> instructions on resetting your<br/> password.
      </h2>
      <button class="close-btn" @click="close">×</button>
    </div>
  </div>
  <!-- Loading overlay -->
</template>

<script setup lang="ts">
import { defineProps, defineEmits, ref, computed, nextTick } from 'vue';
import { useUserStore } from '~/composables/useUserStore';

import * as pkg from 'vue-toastification';
const { useToast } = pkg;
import useVuelidate from '@vuelidate/core';
import {email as emailValidator, required} from "@vuelidate/validators";
import {forgotPassword} from "~/api/userApi";
const toast = useToast();
const { user } = useUserStore();
const step = ref(0);
const emailError = ref<any>('');
const forgotPasswordError = ref(false);
const emailRef = ref('');
const emit = defineEmits(['close']);

const rules = {
  emailRef: {required, email: emailValidator},
};

const $v = useVuelidate(rules, {emailRef});
const loading = ref(false); // Add loading state

const close = () => {
  step.value = 0
  emit('close');
};
const submit = async () => {
  if (step.value === 0) {
    $v.value.$touch();
    if ($v.value.$invalid) {
      return;
    }
    loading.value = true; // Start loading

    try {
      const result = await forgotPassword(emailRef.value);
      if (result) {
        forgotPasswordError.value = false;
        console.log('result', result);
        step.value = 1;
        toast.success(result.message);
      }
    } catch (error: any) {
      emailError.value = error.response.data.message;
      toast.warning(error.response.data.message);
      setTimeout(() => {
        emailError.value = '';
      }, 5000);
    } finally {
      loading.value = false; // Stop loading after the request is complete
    }
  } else {
    emit('close');
  }
};


</script>

<style scoped>
.error-message {
  font-size: 8px;
  line-height: 10px;
  padding: 5px 0;
}
.create-input {
  width: 100%;
  border: .5px solid #b8b8b8;
  border-radius: 10px;
  padding: 10px;
  margin-top: 10px;
}
.create-work-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  overflow: hidden;
}
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 40px 0 40px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.header-2 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 80px 40px 80px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.header-2 h2,
.header h2 {
  font-size: 28px;
  line-height: 36px;
  text-align: center;
}
.close-btn {
  background: none;
  border: none;
  font-size: 32px;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 10px;
}
.content {
  display: flex;
  gap: 20px;
  padding: 0 40px 0 40px;
}
.forgot label {
  font-size: 14px;
}
.footer {
  display: flex;
  justify-content: center;
  background: #EDEDED;
  padding: 20px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  gap: 20px;
}
.create-btn {
  padding: 5px 40px;
}

.create-work-form label {
  font-size: 14px;

}
.create-btn:enabled {
  background-color: #E3FF00;
  cursor: pointer;
  color: black;
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.spinner {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #3498db;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>

